// Translate existing screen field names to the common primitive UI-state schema.
const aliases = { name: "query", search: "query", keyword: "query", school: "schoolId",
  schoolLevel: "schoolStage", term: "termType", semester: "termType",
  courseType: "type", examKind: "type", subject: "subjectId" };
export function encodeListFilters(values) {
  return Object.fromEntries(Object.entries(values).map(([key, value]) => [aliases[key] || key, value]));
}
export function decodeListFilters(saved, defaults) {
  return Object.fromEntries(Object.entries(defaults).map(([key, fallback]) =>
    [key, saved[aliases[key] || key] ?? fallback]));
}
export function validateListFilters(value, defaults, choices = {}) {
  const result = {};
  for (const [key, fallback] of Object.entries(defaults)) {
    let v = typeof value[key] === typeof fallback ? value[key] : fallback;
    if (typeof v === "string") v = v.slice(0, 200);
    if (Array.isArray(choices[key]) && (v !== "" || fallback !== "") && !choices[key].includes(v)) v = fallback;
    result[key] = v;
  }
  return result;
}
export function listPage(page, total, pageSize = 10) {
  const valid = Number.isSafeInteger(page) && page > 0 ? page : 1;
  return total == null ? valid : Math.min(valid, Math.max(1, Math.ceil(total / pageSize)));
}
export function listDate(value, fallback) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return fallback;
  const d = new Date(value + "T00:00:00Z");
  return !Number.isNaN(d.getTime()) && d.toISOString().slice(0, 10) === value ? value : fallback;
}
